var render = function render(){var _vm=this,_c=_vm._self._c;return _c('callout',{staticClass:"callout",attrs:{"iconPath":"icons/heart.svg","title":"מה השלב הבא"},scopedSlots:_vm._u([{key:"text",fn:function(){return [_c('div',{staticClass:"ri-label"},[_vm._v("אחרי התשלום נשלח לך הודעה בווטסאפ ונתחיל את התהליך האישי לבניית התוכניות שלך!\n    ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }